import { reduce } from "et3-type-guards";
import { memoize } from "lodash";
import { observable, runInAction } from "mobx";

import { apiCallWarnUser } from "../../api/user-api/api-call-warn-user";
import { TCorePage } from "../../Types";
import getTBWStore from "../developer-store/tbw-store";
import getReportsStore from "../reports-store";
import changeUserStatus from "./advanced-store/change-user-status";
import getInvestigationCasesStore from "../investigation-cases-store";
import { TEt3PickerSingleValue } from "../../TypesNEW";

class UserStore {
  userIdInput = observable.box<number>(-1);

  selectedLimitInput = observable.box<TEt3PickerSingleValue>({
    label: "50",
    value: "50"
  });
  userPlatformInput = observable.box<TEt3PickerSingleValue>({
    label: "android",
    value: "ANDROID"
  });

  setUserIDInput = (id: number) => {
    runInAction(() => {
      this.userIdInput.set(id);
    });
  };
  setSelectedLimitInput = (limit: TEt3PickerSingleValue) => {
    runInAction(() => {
      this.selectedLimitInput.set(limit);
    });
  };
  setUserPlatformInput = (platform: TEt3PickerSingleValue) => {
    this.userPlatformInput.set(platform);
  };
  changeUserStatus = async ({
    userId,
    userUUID,
    selectedReasons,
    showTBW,
    userStatus,
    userOldStatus,
    pageName
  }: {
    userId: number;
    userUUID: string;
    selectedReasons: number[];
    showTBW: boolean;
    userStatus: string;
    userOldStatus: string;
    pageName: TCorePage;
  }) => {
    return await changeUserStatus({
      userId,
      userUUID,
      selectedReasons,
      showTBW,
      userStatus,
      userOldStatus,
      pageName
    });
  };
  warnUser = async () => {
    const reportId = reduce(() => getTBWStore().TBWExtraData.get().reportID, 0);
    const reportedId = reduce(
      () => getTBWStore().TBWExtraData.get().reportedID,
      0
    );
    const reportedUUID = reduce(
      () => getTBWStore().TBWExtraData.get().reportedUUID,
      ""
    );
    const userUUID = reduce(
      () => getTBWStore().TBWExtraData.get().userUUID,
      ""
    );
    const TBW_ids = getTBWStore().getTWBValuesArray();
    const pageName = getTBWStore().TBWFromPage.get();
    switch (pageName) {
      case "REPORTS": {
        return await getReportsStore().warnReport(
          reportId,
          reportedUUID,
          reportedId,
          TBW_ids,
          pageName
        );
      }
      case "USER_CONVERSATIONS":
      case "USER_ADVANCED": {
        const { status } = await apiCallWarnUser({
          userUUID,
          TBW_ids,
          pageName: pageName
        });
        return status;
      }
      case "INVESTIGATION_CASES": {
        const investigationCaseID = reduce(
          () => getTBWStore().TBWExtraData.get().secondPartyID,
          -1
        );
        const status =
          await getInvestigationCasesStore().updateStatusAndInvestigationCase({
            investigationCaseID: investigationCaseID,
            eventName: "warn",
            fromPage: "INVESTIGATION_CASES",
            userUUID,
            extraData: {
              pageName,
              TBW_ids,
              temporaryBanDays: -1
            }
          });
        return status;
      }
      default:
        return "ERROR";
    }
  };
}

const getUserStore = memoize(
  () => new UserStore(),
  () => 1
);
export default getUserStore;
